import React, { useEffect, useState } from "react";
import "~/css/LoadingScreen.css";
import "~/css/CognitoAuth.css";
import { useTranslation } from "react-i18next";
import { useAuth } from "~/components/auth/CognitoAuth";

const LoadingScreen: React.FC = () => {
  const { t } = useTranslation();
  const [countdown, setCountdown] = useState(60); // 60秒のカウントダウン
  const { signOut, isAuthenticated } = useAuth();

  /**
   * ページをリロードする関数
   * ユーザーが「更新」ボタンをクリックしたときに呼び出される
   * @return void
   */
  const handleReload = () => {
    window.location.reload();
  };

  /**
   * ログアウト処理
   * @return void
   */
  const handleLogout = async () => {
    try {
      await signOut();
    } catch (error) {
      console.error("ログアウトエラー:", error);
    }
  };

  /**
   * コンポーネントのマウント時にカウントダウンを開始する
   * カウントダウンが0になったら自動的にページをリロードする
   * @return void
   */
  useEffect(() => {
    // カウントダウンを1秒ごとに更新
    const countdownInterval = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          window.location.reload();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    /**
     * クリーンアップ関数
     * コンポーネントのアンマウント時にインターバルをクリアする
     * @return void
     */
    return () => {
      clearInterval(countdownInterval);
    };
  }, []);

  return (
    <div className="loading-container">
      <div className="loading-box">
        <p className="loading-message">{t("loading")}</p>
        <button className="reload-button" onClick={handleReload}>
          更新
        </button>
        <p className="reload-prompt">
          {t("reloadPrompt")}
          <br />
          {t("reloadPromptEN")}
        </p>
        <p
          className="countdown-message"
          style={{ visibility: countdown > 0 ? "visible" : "hidden" }}
        >
          {countdown}秒後に画面を更新します
        </p>
        {process.env.REACT_APP_SYSTEM_REQUIREMENT !== "onprem" && (
          <button
            onClick={handleLogout}
            className="settings-logout-button"
            disabled={!isAuthenticated}
          >
            <span className="material-symbols-outlined">logout</span>
            <span>ログアウト</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default LoadingScreen;
